import injector from 'vue-inject';

const YANDEX_COUNTERS = {
  54: [1337757],
  59: [6775807],
  63: [12725662],
  29: [12725860],
  66: [6874273],
  24: [1124739],
  72: [12725777],
  74: [6596923],
  75: [21438901],
};

const REACH_GOALS_PAGE_TYPES = {
  '/': { default: 'Главная' },
  '/about/': { default: 'О премии' },
  '/partners/': { default: 'Партнеры' },
  '/news/': { default: 'Новости' },
  '/members/': { default: 'Участникам' },
  '/docs/': { default: 'Положение' },
  '/live/': { default: 'Награждение' },
  '/404/': { default: '404' },
  '/votes/': (pathParts) => {
    const lastPathPart = pathParts.length > 0 ? pathParts.pop() : ''
    if (Number.isInteger(parseInt(lastPathPart, 10))) {
      return 'Победители';
    }
    return 'Номинации_Голосование_Победители';
  },
}

const REACH_GOALS = {
  partnersBlocks: {
    // Ричгол при попадании блока во вьюпорт пользователя
    userObserve: {
      default: {
        name: 'viewPartnersBlockPeoplesAward',
        props: '{"%Сущность%": {"%Тип страницы%": {"Партнеры премии (блок)": {"Просмотр": '
          + '{"undefined": "%Номер блока%"}}}}}',
      },
    },
    // Ричгол при клике по блоку
    itemClick: {
      default: {
        name: 'clickPartnersBlockPeoplesAward',
        props: '{"%Сущность%": {"%Тип страницы%": {"Партнеры премии (блок)": {"Клик": '
          + '{"undefined": {"%Номер блока%": "%Название партнера%"}}}}}}',
      },
    },
    defaultParams: {
      '%Сущность%': 'Народная премия',
      '%Тип страницы%': '',
      '%Номер блока%': '',
      '%Название партнера%': '',
    },
  },
}

export class YandexCounterService {
  sendReachGoal(
    regionId,
    pageType,
    blockType,
    fieldType,
    valueName,
    goalName,
  ) {
    const fieldName = {};
    fieldName[fieldType] = valueName;

    const blockValue = {};
    blockValue[blockType] = fieldName;

    const currentPageType = pageType;

    const clickPageType = {};
    clickPageType[currentPageType] = blockValue;

    // "Продукт": {PAGE_TYPE_MAP: {blockType: {fieldType: valueName[] }}}
    const params = {
      'Народная премия': clickPageType,
    };

    const newCountersIds = YANDEX_COUNTERS[regionId];
    if (newCountersIds !== undefined && newCountersIds.length > 0) {
      newCountersIds.forEach(counterId => {
        this._sendReachGoal(counterId, goalName, params);
      });
    }
  };

  sendReachGoalWithoutPage(
    regionId,
    blockType,
    fieldType,
    valueName,
    goalName,
  ) {
    const fieldName = {};
    fieldName[fieldType] = valueName;

    const blockValue = {};
    blockValue[blockType] = fieldName;

    const params = {
      'Народная премия': blockValue,
    };

    const newCountersIds = YANDEX_COUNTERS[regionId];
    if (newCountersIds !== undefined && newCountersIds.length > 0) {
      newCountersIds.forEach(counterId => {
        this._sendReachGoal(counterId, goalName, params);
      });
    }
  };

  _isInits = {};
  _q = [];

  _initCounter(counterId) {
    if (typeof this._isInits[counterId] !== 'undefined') {
      return;
    }
    this._isInits[counterId] = counterId;
    console.info(`Init ym counter ${counterId}`)

    const applyOnLoading = () => {
      ym(
        counterId,
        'init',
        {
          ssr: true,
          clickmap: true,
          accurateTrackBounce: true,
          trackLinks: true,
        },
      );
      this._q = this._q.filter(
        (params) => {
          if (params[0] === counterId) {
            ym(...params);
            return false;
          }
          return true;
        },
      );
    }

    const applyOnError = () => {
      this._isInits[counterId] = undefined;
      delete (this._isInits[counterId]);
      console.error(`Error loading the script counter ${counterId}!`)
    }

    (function (m, e, t, r, i, k, a) {
      m[i] = m[i] || function () {
        (m[i].a = m[i].a || []).push(arguments)
      };
      m[i].l = 1 * new Date();
      for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
          return;
        }
      }
      k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
      k.onload = () => applyOnLoading();
      k.onerror = () => applyOnError();
    })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${counterId}`, 'ym');
  }

  _sendReachGoal(
    counterId,
    goalName,
    params,
  ) {
    if (
      typeof window[`yaCounter${counterId}`] === 'undefined'
    ) {
      this._initCounter(counterId)
    }

    if (
      typeof window[`yaCounter${counterId}`] !== 'undefined'
      && 'reachGoal' in window[`yaCounter${counterId}`]
    ) {
      window[`yaCounter${counterId}`].reachGoal(goalName, params)
    } else if (typeof ym !== 'undefined') {
      ym(counterId, 'reachGoal', goalName, params);
    } else {
      this._q.push([counterId, 'reachGoal', goalName, params])
    }
  }

  _preparePageType() {
    if (!document.location) {
      return undefined;
    }

    const path = document.location.pathname.replace('/award/', '/')
    const pathParts = path.split('/').filter(p => p !== '');
    const firstPathPart = pathParts[0] ? (`/${pathParts.shift()}/`) : '/';
    if (REACH_GOALS_PAGE_TYPES[firstPathPart]) {
      const pageTypes = REACH_GOALS_PAGE_TYPES[firstPathPart];
      if (typeof pageTypes === 'function') {
        return pageTypes(pathParts);
      }
      return pageTypes.default;
    }

    return undefined;
  }

  sendBlockReachGoal(reachBlockTid, reachGoalTid, replaceParams) {
    if (
      typeof window['CONTEXT_REGION'] === 'undefined'
      || !window['CONTEXT_REGION']
      || typeof YANDEX_COUNTERS[window.CONTEXT_REGION] === 'undefined'
    ) {
      console.warn(`region is not defined when reach goal TID: [${reachGoalTid}]`);
      return;
    }

    const regionId = window['CONTEXT_REGION'];

    if (
      typeof REACH_GOALS[reachBlockTid] !== 'object'
      || !REACH_GOALS[reachBlockTid]
      || typeof REACH_GOALS[reachBlockTid][reachGoalTid] !== 'object'
      || !REACH_GOALS[reachBlockTid][reachGoalTid]
    ) {
      console.warn(`reach goal TID not exists: [${reachGoalTid}]`);
      return;
    }

    const reachGoal =
      (typeof REACH_GOALS[reachBlockTid][reachGoalTid][regionId] === 'object'
        && REACH_GOALS[reachBlockTid][reachGoalTid][regionId])
        ? REACH_GOALS[reachBlockTid][reachGoalTid][regionId]
        : REACH_GOALS[reachBlockTid][reachGoalTid]['default']

    if (typeof reachGoal !== 'object' || !reachGoal || !reachGoal.name) {
      console.warn(`reach goal not exists when TID: [${reachGoalTid}]`);
      return;
    }


    const replaces = {
      ...(REACH_GOALS[reachBlockTid].defaultParams ? REACH_GOALS[reachBlockTid].defaultParams : {}),
      ...replaceParams,
      '%Тип страницы%': this._preparePageType(),
    }

    let strParams = (reachGoal.props ? reachGoal.props : '')
    for (const key in replaces) {
      if (typeof replaces[key] === 'undefined') {
        continue;
      }
      strParams = strParams.replaceAll(key, replaces[key])
    }

    let params = {}
    try {
      params = JSON.parse(strParams);
      //console.info(params);
    } catch (e) {
      console.error(e);
    }

    const newCountersIds = YANDEX_COUNTERS[regionId];
    if (newCountersIds !== undefined && newCountersIds.length > 0) {
      newCountersIds.forEach(counterId => {
        this._sendReachGoal(counterId, reachGoal.name, params);
      });
    }

  }

  sendPartnerBlockReachGoal(reachGoalTid, params) {
    this.sendBlockReachGoal('partnersBlocks', reachGoalTid, params);
  }
}

injector.service('yandexCounterService', YandexCounterService);



// WEBPACK FOOTER //
// ./src/services/yandex-counter.service.js